import axios from "axios";

const baseUrl = process.env.REACT_APP_APPREG_APIBASEURL;
const hostKey = process.env.REACT_APP_AZFUNCTIONS_HOSTKEY;
const dataFactoryName = process.env.REACT_APP_DATAFACTORYNAME;

const getLeaderOrgTree = async (id, token = null) => {
  const url = `${baseUrl}/api/bulkGet?code=${hostKey}`;

  // Build query
  const doc = {
    collection: "OrgTrees",
    filter: {
      id
    },
    sort: {},
    skip: null,
    limit: null,
    project: {
      _id: 0,
      id: 1,
      tree: 1,
      updatedAt: 1
    },
    confirm: true
  };

  const { data, status } = await axios({
    method: "POST",
    url: url,
    headers: {
      Authorization: `Bearer ${token}`
    },
    data: doc
  });

  if (status === 200) {
    if (data.length > 0) {
      return data[0];
    } else {
      return null;
    }
  } else {
    return null;
  }
};

const getTaskWithinStartDate = async (startDate, token = null) => {
  const url = `${baseUrl}/api/bulkGet?code=${hostKey}`;

  // Build query
  const doc = {
    collection: "Tasks",
    filter: {
      status: {
        $in: ["assigned", "completed", "notCompleted"]
      },
      startDate: {
        $gte: startDate
      }
    },
    sort: {
      dueDate: 1
    },
    skip: null,
    limit: null,
    project: {
      _id: 0,
      id: 1,
      taskTitle: 1,
      leader: 1,
      startDate: 1,
      dueDate: 1,
      status: 1,
      stats: 1
    },
    confirm: true
  };

  const { data, status } = await axios({
    method: "POST",
    url: url,
    headers: {
      Authorization: `Bearer ${token}`
    },
    data: doc
  });

  if (status === 200) {
    return data;
  } else {
    return null;
  }
};

const getLeaderDelegates = async (leaderId, token = null) => {
  const url = `${baseUrl}/api/bulkGet?code=${hostKey}`;

  // Build query
  const doc = {
    collection: "Users",
    filter: {
      "delegation.id": leaderId
    },
    sort: {
      "delegation.displayName": 1
    },
    skip: null,
    limit: null,
    project: {
      _id: 0,
      id: 1,
      name: 1,
      email: 1,
      role: 1,
      registration: 1
    },
    confirm: true
  };

  const { data, status } = await axios({
    method: "POST",
    url: url,
    headers: {
      Authorization: `Bearer ${token}`
    },
    data: doc
  });

  if (status === 200) {
    return data;
  } else {
    return null;
  }
};

const getTaskAssignees = async (taskId, token = null) => {
  const url = `${baseUrl}/api/bulkAggregate?code=${hostKey}`;

  // Build query
  const doc = {
    collection: "Tasks",
    aggregate: [
      {
        $match: {
          id: taskId
        }
      },
      {
        $unwind: {
          path: "$directReports" // Unwind the flat array of directReports
        }
      },
      {
        $project: {
          _id: 0, // Exclude MongoDB's default _id field
          id: "$directReports.id", // Assignee ID
          displayName: "$directReports.displayName", // Assignee name
          jobTitle: "$directReports.jobTitle", // Assignee job title
          group: "$directReports.group", // Assignee group
          completed: "$directReports.completed", // Task completion status
          onTime: "$directReports.onTime", // Task on-time status
          completedOn: "$directReports.completedOn" // Task completion timestamp
        }
      },
      {
        $sort: {
          completed: 1, // Sort by completion status
          onTime: 1 // Sort by on-time status
        }
      }
    ],
    confirm: true
  };

  try {
    const { data, status } = await axios({
      method: "POST",
      url: url,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: doc
    });

    if (status === 200) {
      return data;
    } else {
      console.error("Error Response:", data);
      return null;
    }
  } catch (error) {
    console.error("Axios Error:", error.message);
    return null;
  }
};

const triggerLeaderOrdTreeUpdate = async (accnts, token = null) => {
  const url = `${baseUrl}/api/triggerDataFactoryPipeline?code=${hostKey}`;

  // Build query
  const doc = {
    datafactory: dataFactoryName,
    pipeline: "UpdateOrgTree",
    parameters: {
      mail: accnts
    }
  };

  const { data, status } = await axios({
    method: "POST",
    url: url,
    headers: {
      Authorization: `Bearer ${token}`
    },
    data: doc
  });

  if (status === 200) {
    return data;
  } else {
    return null;
  }
};

const findNode = (id, stack) => {
  return stack.first((node) => {
    return node.model.id === id;
  });
};

export {
  getLeaderOrgTree,
  getTaskWithinStartDate,
  getLeaderDelegates,
  getTaskAssignees,
  triggerLeaderOrdTreeUpdate,
  findNode
};